import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { RewardItemsGrid } from '../shared/rewardItems'
import type { RewardItem, SaveRewardItemInput } from '../shared/rewardItems'

interface RewardItemsSectionProps {
  stepNumber: number
  rewardItems: RewardItem[]
  assignedRewardItemIds: Set<string>
  isLoading: boolean
  isError: boolean
  onRetry: () => void
  onSaveItem: (input: SaveRewardItemInput) => Promise<unknown>
  isSaving: boolean
  isSaveError: boolean
  onResetSaveState: () => void
}

export function RewardItemsSection({
  stepNumber,
  rewardItems,
  assignedRewardItemIds,
  isLoading,
  isError,
  onRetry,
  onSaveItem,
  isSaving,
  isSaveError,
  onResetSaveState,
}: RewardItemsSectionProps) {
  const { t } = useTranslation()

  return (
    <View className="gap-5 rounded-xl border border-border bg-canvas-card p-6">
      <View>
        <View className="flex-row items-baseline gap-2">
          <Text className="text-lg font-semibold text-primary">{stepNumber}.</Text>
          <Text className="text-lg font-semibold text-primary">{t('loyalty.rewardItems.sectionTitle')}</Text>
        </View>
        <Text className="mt-1 text-sm text-secondary">{t('loyalty.rewardItems.subtitle')}</Text>
      </View>

      <RewardItemsGrid
        i18nPrefix="loyalty.rewardItems"
        rewardItems={rewardItems}
        assignedRewardItemIds={assignedRewardItemIds}
        isLoading={isLoading}
        isError={isError}
        onRetry={onRetry}
        onSaveItem={onSaveItem}
        isSaving={isSaving}
        isSaveError={isSaveError}
        onResetSaveState={onResetSaveState}
      />
    </View>
  )
}
